module.exports = __webpack_public_path__ + "img/Namibia.78bcdc0f.png";